<template>
  <div class="teacher_list">
    <div
      v-for="(i,index) in list"
      :key="index"
      class="item"
      @click="viewDetail(i)"
    >
      <div class="wrap_box">
        <!-- <div class="white_space" /> -->
        <img
          class="teacher_img"
          :src="i.headImg"
          mode=""
        >
        <div class="counts">
          <p
            class="font16"
            v-html="i.nickname"
          />
          <span class="course-name-wrap">课程 {{ i.courseCount }}</span>
          <!--<span>班级 {{ i.classroomCount }}</span>-->
        </div>
        <div class="introduce_box">
          <span
            class="intro"
            v-html="i.introduce"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'TeacherList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const router = useRouter()
    const viewDetail = (i) => {
      router.push({
        path: '/teacher/view',
        query: {
          id: i.id
        }
      })
    }
    return {
      viewDetail,
      ...toRefs(props)
    }
  }
})
</script>

<style scoped lang="scss">
.teacher_list {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  .item {
    position: relative;
    min-height: 382px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    // height: 382px;
    .wrap_box {
      position: absolute;
      background: #fff;
      width: 100%;
      min-height: 382px;
      box-sizing: border-box;
      z-index: 10;
      border-radius: 8px;
    }
    .white_space {
      width: 100%;
      height: 18px;
    }
    .teacher_img, .counts {
      display: inline-block;
    }
    .teacher_img {
      width: 100%;
      height: 248px;
      border-radius: 8px 8px 0 0;
    }
    .counts {
      vertical-align: middle;
      margin: 0 auto;
      text-align: center;
      width: 100%;
      p {
        width: 88px;
        height: 32px;
        line-height: 32px;
        margin: 9px auto 8px;
        background: rgba(34, 86, 246, 0.1);
        border-radius: 17px;
        font-weight: bold;
        font-size: 18px;
        color: #2256F6;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .course-name-wrap {
        margin: 0 auto 8px;
        padding: 0 12px;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .introduce_box {
      position: relative;
      padding: 0 12px;
      text-align: center;
      .intro{
        overflow : hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
    }
    &:hover .wrap_box{
    //   padding-bottom: 20px;
      z-index: 11;
      box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    //   transform: translateY(-2px);
    //   transition: all 0.3s;
    }
    &:hover .introduce_box{
      -webkit-line-clamp: inherit;
    }
  }
}
</style>
